// import { useRouter } from 'vue-router';

export function useErrorHandling() {
    // const router = useRouter();

    const handleApiError = (errorMessage) => {
        console.error('API Error:', errorMessage);
        //router.push({ query: { error: errorMessage }});
    };

    return { handleApiError };
}